import { useCallback } from "react";
import { useDashboardContext } from "../contexts/dashboard-context";
import { useEnvContext } from "../contexts/env-context";
import { useAppContext } from "./useAppContext";
import { useErrorHandling } from "./useErrorHandling";

export function useSmartFilterLoader(): eXpress.creator.rendering.SmartFilterLoader | undefined {
	const { createErrorHandler } = useErrorHandling();
	const { jsUrl } = useEnvContext();
	const {
		platform: { wasm },
		logger,
	} = useAppContext();
	const dashboard = useDashboardContext();

	const areSmartFiltersSupported = dashboard.areSmartFiltersSupported();

	const loader = useCallback(async () => {
		try {
			return await eXpress.creator.rendering.loadSmartFilterAsync(jsUrl, wasm, logger);
		} catch (err) {
			// TODO: [PV] Currently we just log an error and continue without smart filter functionality. Provide asmjs fallback?
			const errorHandler = createErrorHandler();
			errorHandler(err);
			throw err;
		}
	}, [jsUrl, wasm, logger, createErrorHandler]);

	return areSmartFiltersSupported ? loader : undefined;
}
